export default __webpack_public_path__ + "static/media/labs (5).c23f65b5.JPG";